var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.96 8l5.149-5.157-.962-.958L8 7.04 2.845 1.892l-.96.961L7.04 8.001l-5.148 5.155.96.96L8.002 8.96l5.155 5.148.959-.96z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelSmall);
export default __webpack_public_path__ + "static/media/cancel-small.5fe5a9840f2a463cc8eab474f3cbafca.svg";
export { ForwardRef as ReactComponent };